export const UPLOAD_FILE_ACTION = 'app/BankStatementUploader/UPLOAD_FILE_ACTION';
export const DELETE_FILE_ACTION = 'app/BankStatementUploader/DELETE_FILE_ACTION';
